$(document).ready(function () {
    $("#main-content .owl-carousel").owlCarousel({
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        loop: true,
        autoplay: true,
        autoplayTimeout: 6000,
        mouseDrag: true,
        touchDrag: false,
        nav: false,
        dots: true,
        items: 1,
        lazyLoad: true,
        nav: false,
       
    });

    //if (matchMedia(Foundation.media_queries.large).matches) {
    //    /*$.adaptiveBackground.run();*/
    //    $(".slider-background").css({ "transition": "all 500ms ease-out" });
    //}
});